<div class="container-fluid crud-button">
   <div class="row crud-search" >
      <ngx-crud-title></ngx-crud-title>
    </div>
</div>
   <ng-content></ng-content>
   